import { useEffect } from 'react'
import { state } from 'utils/hooks/useValidator'

let currentFocusNode
document.addEventListener('focusin', e => (currentFocusNode = e.target))
document.addEventListener('focusout', () => (currentFocusNode = null))

const useFocusOnError = (ref, error, enabled) => {
  useEffect(() => {
    ref.current.dataset.focusOnError = true
  }, [ref, enabled])

  useEffect(() => {
    if (!error || !enabled) return
    if (currentFocusNode === ref.current) return
    if (
      !currentFocusNode ||
      !currentFocusNode.dataset ||
      !currentFocusNode.dataset.focusOnError
    ) {
      ref.current.focus()
      return
    }

    const focusCadidates = Array.from(
      document.querySelectorAll('[data-focus-on-error]')
    )
    const currentFocusNodeIndex = focusCadidates.findIndex(
      n => n === currentFocusNode
    )
    const refNodeIndex = focusCadidates.findIndex(n => n === ref.current)
    if (refNodeIndex < currentFocusNodeIndex) {
      ref.current.focus()
    }
    // eslint-disable-next-line
  }, [ref, error, enabled, state.count])
}

export default useFocusOnError
